export default "__VITE_ASSET__BFfq4OLG__"